import classNames from "classnames";
import PropTypes from "prop-types";

import { InlineLoaderIcon } from "@/components/data-display/icon";

function PrimaryBtn({ onClick, btnText, className, isLoading, isDisabled }) {
  return (
    <button
      onClick={onClick}
      disabled={isDisabled || isLoading}
      className={classNames(
        {
          "bg-disable-bg text-disable-text": isDisabled,
          "bg-primary text-white transition-colors duration-500 hover:bg-primary-900 active:bg-primary-900":
            !isDisabled,
        },
        `relative rounded-[10px] text-[1.125rem] font-semibold tracking-normal ${className}`
      )}
    >
      {isLoading && (
        <InlineLoaderIcon className="absolute left-[calc(50%_-_1.5rem)] top-[calc(50%_-_1.5rem)] inline-block h-[3rem] w-[3rem] text-white" />
      )}
      <p
        className={classNames(
          {
            invisible: isLoading,
            visible: !isLoading,
          },
          "inline-block"
        )}
      >
        {btnText}
      </p>
    </button>
  );
}

PrimaryBtn.propTypes = {
  isLoading: PropTypes.bool,
  onClick: PropTypes.func,
  btnText: PropTypes.string,
  className: PropTypes.string,
  isDisabled: PropTypes.bool,
};

PrimaryBtn.defaultProps = {
  isLoading: false,
  isDisabled: false,
};

export default PrimaryBtn;
